import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoadingService } from 'src/app/services/loading.service';
import { LoginService } from 'src/app/services/login.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TermsConditionsComponent } from 'src/app/components/terms-conditions/terms-conditions.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  isIEOrEdge: boolean;

  userName: string;
  loggedInUser:string;
  password: string;
  authenticated: boolean;
  authenticationFailure: string;

  pwInputType = "password";
  loginClicked = false;

  private unsubscribe: Subject<any> = new Subject();
  loading: boolean = false;
  returnUrl: string;

  constructor(
    private oauthService: OAuthService,
    private loginService: LoginService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private loadingService: LoadingService) {
  /* If navigating to this, open login modal */
    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) { /* Your code goes here on every router change */
        if (this.authenticated == false) {
          //this.open();
        }}
    });
  }

  ngOnInit() {
    this.isIEOrEdge = /msie\s|trident\/|edg\//i.test(window.navigator.userAgent);
    /* make sure we have both the Identity token and the localStorage data */
    if (!!this.oauthService.getAccessToken() && localStorage.getItem('loggedInUser') != null) {
      return true;
    }

    this.loginService.expired.subscribe(expired => {
      if (expired === true) {
        this.expiredPopup();
        this.loginService.changeExpired(false);
      }
    });

    this.loginService.loggedInUser.subscribe(user => {
      this.loggedInUser = user;
    })

    this.loadingService.currentLoading
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(loading => {
      this.loading = loading;
    });

    this.loginService.authenticated
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(authenticated => {
        this.authenticated = authenticated;
      })
  }

  openTermsConditions() {
    const modalRef = this.modalService.open(TermsConditionsComponent, {
      backdrop: 'static',
      keyboard: false
    });

    modalRef.result.then((result) => {
      if (result === 'accepted') {
        // Proceed with login or show success
      } else {
        // Optionally handle decline
      }
    }).catch((reason) => {
      // Modal dismissed
    });
  }


  showPasswordToggle() {
    if (this.pwInputType === "password") {
      this.pwInputType = "text";
    } else {
      this.pwInputType = "password";
    }
  }

  async login() {
    this.loginClicked = true;

    const modalRef = this.modalService.open(TermsConditionsComponent, {
      backdrop: 'static',
      keyboard: false
    });

    try {
      const result = await modalRef.result;

      if (result === 'accepted') {
        let loginResult = await this.loginService.login(this.userName, this.password);
        this.authenticationFailure = loginResult.failureMessage;
        this.password = null;
        this.loginClicked = false;

        if (!this.authenticationFailure) {
          setTimeout(() => {
            this.modalService.dismissAll();
          }, 1000);
        }
      } else {
        this.loginClicked = false;
      }

    } catch {
      // Modal dismissed
      this.loginClicked = false;
    }
  }

  expiredPopup() {
    //this.modalService.open(this.expired);
    setTimeout(() => {
      //this.modalService.dismissAll();
    }, 2500);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
